module.exports = __webpack_public_path__ + "static/img/footer_banner_btn.9115369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/footer_banner_btn.png
// module id = 2iky
// module chunks = 34